
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1941"}},[_c('path',{attrs:{"data-name":"Rectangle 2667","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1940","transform":"translate(-424.173 -307.174)"}},[_c('path',{attrs:{"data-name":"Path 1243","d":"M447.173 317.174h-9v-9a1 1 0 00-1-1h-12a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1v-12a1 1 0 00-1-1z","fill":"#f9a36c"}}),_c('rect',{attrs:{"data-name":"Rectangle 2668","width":"6","height":"6","rx":"1","transform":"translate(424.173 307.174)","fill":"#f9a36c"}}),_c('rect',{attrs:{"data-name":"Rectangle 2669","width":"6","height":"6","rx":"1","transform":"translate(424.173 325.131)","fill":"#f9a36c"}}),_c('rect',{attrs:{"data-name":"Rectangle 2670","width":"6","height":"6","rx":"1","transform":"translate(442.173 325.131)","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Path 1244","d":"M447.173 317.174h-9v-9a1 1 0 00-1-1h-12a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1v-12a1 1 0 00-1-1zm-21-8h2v2h-2zm2 19.957h-2v-2h2zm2 .043v-3.043a1 1 0 00-1-1h-3v-11.957h3a1 1 0 001-1v-3h6v8h-3a1 1 0 000 2h3v3a1 1 0 002 0v-3h8v5.957h-3a1 1 0 00-1 1v3.043h-12zm16-.043h-2v-2h2z"}})])])])
          )
        }
      }
    